import { COMPONENT_NAME as DEPOSITORY_PARAMETERS_COMPONENT_NAME, IMRDepositoryParametersComponent } from './depository-parameters.component'

export const DEPOSITORY_PARAMETERS_MODULE_NAME = 'simax.common.depository-parameters'

const module = angular.module(DEPOSITORY_PARAMETERS_MODULE_NAME, [])

module.component(DEPOSITORY_PARAMETERS_COMPONENT_NAME, new IMRDepositoryParametersComponent())
